import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function postTimeSheet({ body }) {
  return BaseService.post(REST.TIMESHEETS, body);
}

function uploadTimeSheet({ body }) {
  return BaseService.post(REST.TIME_SHEETS_IMPORT, body);
}

function putTimeSheet({ body, id }) {
  return BaseService.put(REST.TIMESHEETS_ID(id), body);
}

function getTimeSheets(params) {
  return BaseService.get(REST.TIMESHEETS, {
    params: paramsFilter({ params }),
  });
}

function deleteTimeSheet({ id }) {
  return BaseService.delete(REST.TIMESHEETS_ID(id));
}

export default {
  postTimeSheet,
  putTimeSheet,
  getTimeSheets,
  deleteTimeSheet,
  uploadTimeSheet,
};
